import script from "./ViewSpecialApproval.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSpecialApproval.vue?vue&type=script&setup=true&lang=js"

import "./ViewSpecialApproval.vue?vue&type=style&index=0&id=7525ea37&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7525ea37"]])

export default __exports__